// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Quick Links */
.ql-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 160px;
  padding: 8px 10px;
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.15s ease, transform 0.1s ease;
  cursor: pointer;
}

.ql-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
  text-decoration: none;
  color: inherit;
}

.ql-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 0;
  margin-right: 8px;
  flex-shrink: 0;
}

.ql-label {
  font-size: 0.75rem;
  font-weight: 500;
  text-align: left;
  line-height: 1.2;
  color: #6c757d;
  word-break: break-word;
}

.ql-item:hover .ql-label {
  color: #343a40;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
